import { render, staticRenderFns } from "./noticeDialog.vue?vue&type=template&id=1aeb3450&scoped=true"
import script from "./noticeDialog.vue?vue&type=script&lang=js"
export * from "./noticeDialog.vue?vue&type=script&lang=js"
import style0 from "./noticeDialog.vue?vue&type=style&index=0&id=1aeb3450&prod&lang=scss&scoped=true"
import style1 from "./noticeDialog.vue?vue&type=style&index=1&id=1aeb3450&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeb3450",
  null
  
)

export default component.exports